import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';

import { CreateZeeFinancialApiPayload } from '@/actions/zee-financial/createZeeFinancial';
import { GetZeeFinancialApiResponse } from '@/actions/zee-financial/getZeeFinancial';
import { updateZeeFinancial } from '@/actions/zee-financial/updateZeeFinancial';
import { ApiResponse } from '@/types/response.type';

export interface UseUpdateZeeFinancialReturn {
  mutate: (
    payload: CreateZeeFinancialApiPayload
  ) => Promise<ApiResponse<GetZeeFinancialApiResponse> | undefined>;
  result: ApiResponse<GetZeeFinancialApiResponse> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useUpdateZeeFinancial = (): UseUpdateZeeFinancialReturn => {
  const queryClient = useQueryClient();

  const mutation: UseMutationResult<
    ApiResponse<GetZeeFinancialApiResponse> | undefined,
    Error,
    CreateZeeFinancialApiPayload
  > = useMutation({
    mutationFn: updateZeeFinancial,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['zee-financial'] });
    },
  });

  return {
    mutate: mutation.mutateAsync,
    result: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isPending,
  };
};
